<div class="help-dialog">
    <sync-dialog [config]="{
        title: 'Get help',
        isClosable: true,
      }" [isFullScreen]="false" [open]="openHelpLinkDialog" [onClose]="closeHelpDialog">  
      <div class="help-link-dialog-container">
        <p>Visit the Sync help center for tutorials, troubleshooting steps, ways to get help, and more.</p>
        <sync-list [ListItems]="helpCategories"></sync-list>
     </div>       
    </sync-dialog>
  </div>